import React from 'react';
import PropTypes from 'prop-types';

import { transUTL } from '../../utils/transUTL';

const Dropdown = ({
  handleOnChange,
  target,
  obj,
  objKey,
  handelRadio,
  name,
  transType,
}) => {
  return (
    <div className="dropdown">
      {obj.map((item) => {
        const checked = target === item[objKey].toLowerCase();
        const title = item[objKey].toLowerCase();

        return (
          <label
            htmlFor={item[objKey].toLowerCase()}
            key={item[objKey].toLowerCase()}
            className="dropdown__option"
            onClick={() => handelRadio(item[objKey].toLowerCase())}
          >
            <h4 className="dropdown__title">
              {transUTL(`${transType}.${title}`)}
            </h4>

            <div className="dropdown__radio">
              <input
                id={item[objKey].toLowerCase()}
                type="radio"
                name={name}
                value={item[objKey].toLowerCase()}
                onChange={handleOnChange}
                defaultChecked={checked}
              />

              <label
                htmlFor={item[objKey].toLowerCase()}
                className="radio-label"
                name={name}
              />
            </div>
          </label>
        );
      })}
    </div>
  );
};

Dropdown.propTypes = {
  handleOnChange: PropTypes.func.isRequired,
  target: PropTypes.string.isRequired,
  obj: PropTypes.array.isRequired,
  objKey: PropTypes.string.isRequired,
  handelRadio: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  transType: PropTypes.string.isRequired,
};

export default Dropdown;
